import { useCallback } from 'react';
import { MOOD_LEVELS, type MoodLevel } from '@shared/constants';
import { Button } from '@/components/Button';
import { ScrollShadow } from '@/components/ScrollShadow';
import { navigate } from '@/features/routing';
import { getDebugRing } from '@/lib/devUtils';
import { useMoodRecordDraft } from '@/lib/moodUtils/MoodRecordDraftContext';
import { getMoodUI } from '@/lib/moodUtils/getMoodUIDetails';
import { clx } from '@/lib/utils';

export const MoodSelectionForm = () => {
  const { moodRecordDraft, updateMoodRecordDraft } = useMoodRecordDraft();

  const handleSubmit = useCallback(
    async (mood: MoodLevel) => {
      if (mood !== moodRecordDraft?.mood) {
        await updateMoodRecordDraft({ mood });
      }
      navigate(`/mood-log-entry/step2`);
    },
    [moodRecordDraft, updateMoodRecordDraft]
  );

  if (!moodRecordDraft) return null;

  return (
    <div
      className={clx('flex min-h-48 w-full max-w-xs shrink grow basis-full', getDebugRing('blue'))}
    >
      <ScrollShadow
        innerClassName={clx(
          'flex min-h-48 shrink grow basis-full flex-col gap-6 overflow-y-auto pb-8 text-center',
          '[@media(min-height:750px)]:justify-center',
          getDebugRing('red')
        )}
      >
        {Object.values(MOOD_LEVELS).map((mood) => {
          const { faceEmoji, bgColor } = getMoodUI(mood);
          return (
            <Button
              variant="buttonPrimary"
              key={mood}
              name="mood"
              type="button"
              value={mood}
              className={clx(bgColor, 'basis-18 flex min-h-16 items-center py-0 drop-shadow')}
              onClick={() => handleSubmit(mood)}
            >
              <div className="scale-75">{faceEmoji}</div>
              <div className="w-1/2 text-center text-2xl font-semibold">{mood}</div>
            </Button>
          );
        })}
      </ScrollShadow>
    </div>
  );
};
